var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Select, Input, useId, useValue, useFocus, createClassName, flatObj } from '../common';
import Translate from '../Translate';
import translate from '../../lib/utils/translate';
import cn from 'classnames';
import { useIntl } from 'react-intl';

var pad = function pad(num) {
  return ('' + num).length === 1 ? '0' + num : num;
};
var yearRange = new Array(100).fill(null, 0, 100).map(function (y, i) {
  return new Date().getFullYear() - 18 - i;
});
var monthRange = new Array(12).fill(null, 0, 12).map(function (m, i) {
  return i + 1;
});
var dayRange = new Array(31).fill(null, 0, 31).map(function (d, i) {
  return i + 1;
});

var BirthdateInput = function BirthdateInput(props) {
  var intl = useIntl();

  var yearInput = {
    id: useId(),
    value: useValue(props.value.split('/')[0]),
    focus: useFocus()
  };

  var monthInput = {
    id: useId(),
    value: useValue(props.value.split('/')[1]),
    focus: useFocus()
  };

  var dayInput = {
    id: useId(),
    value: useValue(props.value.split('/')[2]),
    focus: useFocus()
  };

  var createValue = function createValue() {
    var _Object$values;

    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.values((_Object$values = {}, _defineProperty(_Object$values, yearInput.id, yearInput.value.value), _defineProperty(_Object$values, monthInput.id, monthInput.value.value), _defineProperty(_Object$values, dayInput.id, dayInput.value.value), _defineProperty(_Object$values, id, value), _Object$values)).join('/');
  };

  var _onChange = function _onChange(e) {
    return props.onChange && props.onChange(e, createValue(e.target.id, e.target.value));
  };

  var _onBlur = function _onBlur(e) {
    return props.onBlur && props.onBlur(e, createValue(e.target.id, e.target.value));
  };

  var inputs = [yearInput, monthInput, dayInput];
  var className = createClassName('tg-birthdate-input', {
    hasValue: inputs.some(function (i) {
      return i.value.hasValue;
    }),
    hasFocus: inputs.some(function (i) {
      return i.focus.hasFocus;
    }),
    status: props.status
  });

  return React.createElement(
    'div',
    { className: cn(props.className, className) },
    React.createElement(
      'label',
      { className: 'tg-birthdate-input__label' },
      props.label
    ),
    React.createElement(
      Select,
      _extends({}, flatObj(yearInput), {
        autoFocus: props.autoFocus && !yearInput.value.hasValue,
        name: props.name + '_year',
        label: React.createElement(Translate, { id: 'label.year-of-birth', defaultMessage: 'Year' }),
        status: props.status,
        onChange: function onChange(e) {
          yearInput.value.onChange(e.target.value);
          _onChange(e);
        },
        onBlur: function onBlur(e) {
          yearInput.focus.onBlur();
          _onBlur(e);
        } }),
      !yearInput.value.hasValue && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({ id: 'label.year-of-birth', defaultMessage: 'Year' }, intl)
      ),
      yearRange.map(function (y) {
        return React.createElement(
          Select.Option,
          { key: y, value: y },
          y
        );
      })
    ),
    React.createElement(
      Select,
      _extends({}, flatObj(monthInput), {
        autoFocus: props.autoFocus && yearInput.value.hasValue && !monthInput.value.hasValue,
        name: props.name + '_month',
        label: React.createElement(Translate, { id: 'label.month-of-birth', defaultMessage: 'Month' }),
        status: props.status,
        onChange: function onChange(e) {
          monthInput.value.onChange(e.target.value);
          _onChange(e);
        },
        onBlur: function onBlur(e) {
          monthInput.focus.onBlur();
          _onBlur(e);
        } }),
      !monthInput.value.hasValue && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({ id: 'label.month-of-birth', defaultMessage: 'Month' }, intl)
      ),
      monthRange.map(function (m) {
        return React.createElement(
          Select.Option,
          { key: m, value: pad(m) },
          m
        );
      })
    ),
    React.createElement(
      Select,
      _extends({}, flatObj(dayInput), {
        autoFocus: props.autoFocus && yearInput.value.hasValue && monthInput.value.hasValue,
        name: props.name + '_day',
        label: React.createElement(Translate, { id: 'label.day-of-birth', defaultMessage: 'Day' }),
        status: props.status,
        onChange: function onChange(e) {
          dayInput.value.onChange(e.target.value);
          _onChange(e);
        },
        onBlur: function onBlur(e) {
          dayInput.focus.onBlur();
          _onBlur(e);
        } }),
      !dayInput.value.hasValue && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({ id: 'label.day-of-birth', defaultMessage: 'Day' }, intl)
      ),
      dayRange.map(function (d) {
        return React.createElement(
          Select.Option,
          { key: d, value: pad(d) },
          d
        );
      })
    ),
    React.createElement(Input, { type: 'hidden', name: props.name, value: createValue() }),
    React.createElement(
      'div',
      { className: 'tg-birthdate-input__status-text' },
      props.statusText
    )
  );
};

export default BirthdateInput;